module.exports = __webpack_public_path__ + "img/logo_7.0e03a205.jpg";